import { useEffect, useState } from 'react';

import { useFormik } from 'formik';
import { getLogoMobileQuery } from '@features/form-phones/api';
import { parseNumber } from '@features/form-phones/components/registration/utils';

import { Button, If, InfoPayment, Input } from '@ui';
import { checkFeeInfo, getAmountSStorage, numberFormat } from '@utils';
import { ITransactionType } from '@entities/checkout';
import { BASE_URL_LOGOS } from '@constants';
import { AmountButton } from '@entities/amount-button';

import { validationSchemaFormPhones } from './schema';
import { IRegFormPhone, IRegistrationForm } from './types';

export const RegistrationForm = ({
  handleSetValuePhone,
  handleNextStep,
  checkMobi,
  isLoading,
  checkout,
  typeTransaction,
  isTokenization = false,
  logos = [],
  enterAmount,
}: IRegistrationForm) => {
  const [clientAmount, setClientAmount] = useState<string>('');
  const [isCalculated, setIsCalculated] = useState<boolean>(true);

  const showInfoPaymentInAmountButton = Boolean(
    enterAmount?.payload?.enterAmount
  );

  const checkIsCalculated = showInfoPaymentInAmountButton
    ? isCalculated
    : false;

  const { values, setFieldValue, handleSubmit, isValid, errors } =
    useFormik<IRegFormPhone>({
      initialValues: { phone: '+992 ' },
      validationSchema: validationSchemaFormPhones,
      onSubmit: (values) => {
        checkMobi(values, {
          onSuccess: (data) => {
            if (data.code === 200) {
              handleNextStep();
            }
          },
        });
      },
    });

  const { data: logo } = getLogoMobileQuery(parseNumber(values.phone));

  const handleChange = (value: string): void => {
    handleSetValuePhone(value);
    setFieldValue('phone', value);
  };

  const infoPay: ITransactionType | undefined =
    checkout?.transactionTypes?.find(
      (transactionType) => transactionType.groupName === typeTransaction
    );

  const max: string = checkFeeInfo('max', String(infoPay?.feeInfo.max));
  const min: string = checkFeeInfo(
    'min',
    String(infoPay?.feeInfo.min),
    `${max ? ',' : ''}`
  );
  const infoStatic: string = checkFeeInfo(
    ' +',
    String(infoPay?.feeInfo.static),
    ','
  );

  useEffect(() => {
    const amount = getAmountSStorage();
    if (amount !== null) {
      setClientAmount(amount);
    } else {
      setClientAmount('');
    }
  }, []);

  return (
    <>
      <form onSubmit={handleSubmit} className="flex w-full flex-col gap-5">
        <Input
          maskChar=" "
          placeholder="+992 "
          mask="+999 999 99 99 99"
          label="Номер телефона"
          classNameEndIcon="!top-3 sm:!top-2.5"
          initialValue={values.phone}
          errorText={errors.phone || logo?.detailedInfo}
          isError={Boolean(errors.phone || logo?.detailedInfo)}
          onChange={(value) => handleChange(value)}
          endIcon={
            <If
              condition={Boolean(logo?.brand && logo?.brand !== 'default.png')}
            >
              <img
                alt="Logo"
                width={30}
                height={30}
                src={`${BASE_URL_LOGOS}/logos/${logo?.brand}`}
              />
            </If>
          }
        />

        <AmountButton
          value={clientAmount}
          type={typeTransaction}
          enterAmountData={enterAmount}
          disabled={getAmountSStorage() !== null}
          onCommissionCalculated={setIsCalculated}
          showInfoPayment={showInfoPaymentInAmountButton}
          onClientAmount={(e) => setClientAmount(e.target.value)}
        />

        <If condition={!isTokenization && !showInfoPaymentInAmountButton}>
          <InfoPayment
            className="mb-4"
            info={[
              {
                label: 'Комиссия',
                value: `${numberFormat(Number(infoPay?.totalFee))} c. ( ${infoPay?.feeInfo?.percent}%${infoStatic} ${min} ${max})`,
              },
              {
                label: 'Сумма к зачислению',
                value: `${numberFormat(Number(checkout?.amount))} с.`,
              },
              {
                label: 'К оплате',
                value: `${numberFormat(Number(infoPay?.totalAmount))} с.`,
              },
            ]}
          />
        </If>
        <Button
          type="submit"
          disabled={
            (!isValid || checkIsCalculated) && getAmountSStorage() === null
          }
          isLoading={isLoading}
          className="w-full justify-center"
        >
          Далее
        </Button>
      </form>
      <div className="mx-auto mt-8 flex items-center justify-center gap-8 sm:mt-4 sm:w-full sm:gap-4">
        {logos.map((logo) => (
          <img
            key={logo?.logoInfo}
            src={`${BASE_URL_LOGOS}/logos/${logo?.logoInfo}`}
            alt={logo?.logoInfo}
            width={40}
            height={40}
          />
        ))}
      </div>
    </>
  );
};
